import type { FunctionComponent } from "react";

import { Container, Description, Image, ImageContainer, TextContainer, Title } from "./styles";
type Props = {
  className?: string;
  description: string;
  image: StaticImageData;
  title: string;
};

export const WhyPostiesItem: FunctionComponent<Props> = ({
  className,
  description,
  image,
  title,
}) => (
  <Container className={className}>
    <ImageContainer>
      <Image src={image.src} />
    </ImageContainer>
    <TextContainer>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </TextContainer>
  </Container>
);
WhyPostiesItem.displayName = "WhyPostiesItem";
